import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CamposPadroes } from "../../shared/CamposPadroes";
import { getUsuario, putUsuario } from "../../services/apiUsuario";
import { erroToastify } from "../../shared/validacaoToastify";
import { Helmet } from "react-helmet";
import FormFieldsGroup from "../../components/camposFormulario/camposFormulario";
import CamposEndereco from "../../components/camposEndereco/camposEndereco";
import { ToastContainer, toast } from "react-toastify";
import { getCidade } from "../../services/apiCidade";

interface Usuario {
  cdUsuario: string;
  cdCidade: number;
  nmUsuario: string;
  nmEmail: string;
  nmSexo: string;
  nmLogradouro: string;
  nmBairro: string;
  mComplemento: string;
  dsLogin: string;
  dsSenha: string;
  dsCpf: string;
  dsContato: string;
  dsContatoOpcional: string;
  dsCep: string;
  dtNascimento: string;
  nrLogradouro: string;
  dmResidencial: boolean;
}

export default function AlterarUsuario() {
  const navigate = useNavigate();
  const { cdUsuario } = useParams();
  const [usuario, setUsuario] = useState<Usuario>();
  const [validacaoAtiva, setValidacaoAtiva] = useState<boolean>(false);
  const [cidade, setCidade] = useState<{
    cdCidade: number;
    nmCidade: string;
  } | null>(null);
  const [formValues, setFormValues] = useState({
    cdCidade: "",
    nmUsuario: "",
    nmEmail: "",
    dsLogin: "",
    dsSenha: "",
    dsCpf: "",
    dtNascimento: "",
    nmSexo: "",
    dsContato: "",
    dsContatoOpcional: "",
    dsCep: "",
    nmLogradouro: "",
    nrLogradouro: "",
    nmBairro: "",
    nmComplemento: "",
    dmResidencial: false,
    perfil: "",
    cidade: "",
    confirmacaoSenha: "",
  });
  const applyTelefoneFormat = (value: string) => {
    const cleanedValue = value.replace(/\D/g, ""); 
    const match = cleanedValue.match(/^(\d{2})(\d{0,5})(\d{0,4})$/); 
    if (match) {
      return `(${match[1]}) ${match[2]}${match[3] ? "-" + match[3] : ""}`; 
    }
    return value; 
  };
  const applyCEPFormat = (value: string) => {
    const cleanedValue = value.replace(/\D/g, ""); 
    const match = cleanedValue.match(/^(\d{5})(\d{0,3})$/); 
    if (match) {
      return `${match[1]}${match[2] ? "-" + match[2] : ""}`; 
    }
    return value; 
  };
  const applyCPFFormat = (value: string) => {
    const cleanedValue = value.replace(/\D/g, "").slice(0, 11);
    return cleanedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };
  const applyMask = (fieldName: string, value: string) => {
    switch (fieldName) {
      case "dsCpf":
        return applyCPFFormat(value);
      case "dsContato":
        return applyTelefoneFormat(value);
      case "dsContatoOpcional":
        return applyTelefoneFormat(value);
      case "dsCep":
        return applyCEPFormat(value);
      default:
        return value;
    }
  };
  const getMaxlength = (fieldName: string) => {
    switch (fieldName) {
      case "dsCpf":
        return 14;
      case "dsContato":
      case "dsContatoOpcional":
        return 15;
      case "dsCep":
        return 10;
      default:
        return Infinity;
    }
  };
  const handleMaskChange = (name: string, value: string) => {
    if (name === "dsCpf") {
      const cleanValue = value.replace(/\D/g, ""); 
      setFormValues({ ...formValues, [name]: cleanValue });
    } else {
      const maskedValue = applyMask(name, value);
      const maxLength = getMaxlength(name);
      if (maskedValue.length <= maxLength) {
        setFormValues({ ...formValues, [name]: maskedValue });
      }
    }
  };
  const handleFieldBlur = (name: string, value: string) => {
    if (name === "dsCpf") {
      const cleanValue = value.replace(/\D/g, "");
      const maskedValue = applyCPFFormat(cleanValue);
      setFormValues({ ...formValues, [name]: maskedValue });
    } else {
      const cleanValue = value.replace(/\D/g, "");
      const maskedValue = applyMask(name, cleanValue);
      const maxLength = getMaxlength(name);
      if (maskedValue.length <= maxLength) {
        setFormValues({ ...formValues, [name]: maskedValue });
      }
    }
  };
  const handleFieldChange = (
    name: string,
    value: string | number | boolean
  ) => {
    setFormValues({ ...formValues, [name]: value });
    setValidacaoAtiva(false);
  };
  const handleNumberChange = (name: string, value: string) => {
    const numericValue = value.replace(/\D/g, "");
    setFormValues({ ...formValues, [name]: numericValue });
    setValidacaoAtiva(false);
  };
  const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const dataPresente = new Date();
    const envioDeDados = {
      cdUsuario: Number(cdUsuario),
      nmUsuario: formValues.nmUsuario,
      dsLogin: formValues.dsLogin,
      nmEmail: formValues.nmEmail,
      dsCpf: formValues.dsCpf.replace(/\D/g, "").slice(0, 11),
      dtNascimento: formValues.dtNascimento,
      nmSexo: formValues.nmSexo,
      dsContato: formValues.dsContato.replace(/\D/g, ""),
      dsContatoOpcional: formValues.dsContatoOpcional.replace(/\D/g, ""),
      dsCep: formValues.dsCep.replace(/\D/g, ""),
      nmLogradouro: formValues.nmLogradouro,
      nrLogradouro: formValues.nrLogradouro,
      nmBairro: formValues.nmBairro,
      nmComplemento: formValues.nmComplemento,
      dmResidencial: formValues.dmResidencial,
      cdPerfil: 2,
      cdCidade: formValues.cdCidade ? formValues.cdCidade : 0,
      ...CamposPadroes.toObjeto(
        1,
        1,
        dataPresente.toISOString(),
        dataPresente.toISOString(),
        true
      ),
    };
  
      try {
        const response = await putUsuario({ ...envioDeDados });
        const successMessage = "O usuário foi alterado com sucesso!";
        navigate(
          `/milshop/usuario/consultar?successMessage=${encodeURIComponent(
            successMessage
          )}`
        );
      } catch (error: any) {
        if (!formValues.dtNascimento) {
          erroToastify("Data de nascimento é um campo obrigatório.");
          setValidacaoAtiva(true);
        } else if (!formValues.nmSexo) {
          erroToastify("Sexo é um campo obrigatório.");
          setValidacaoAtiva(true);
        } 
        if (error.response.data) {
          erroToastify(error.response.data);
          setValidacaoAtiva(true);
        }
      }
   
  };
  const fetchUsuario = async (cd: any) => {
    try {
      const response = await getUsuario(cd);
      if (response) {
        setUsuario(response.data);
        setFormValues({
          ...response.data,
          dtNascimento: convertDataFormat(response.data.dtNascimento), 
          dsSenha: '',
          confirmacaoSenha: '',
          dsContato: applyTelefoneFormat(response.data.dsContato),
          dsContatoOpcional: applyTelefoneFormat(
            response.data.dsContatoOpcional
          ),
          dsCpf: applyCPFFormat(response.data.dsCpf),
          dsCep: applyCEPFormat(response.data.dsCep),
          nrLogradouro: response.data.nrLogradouro.toString(),
        });
        fetchCidade(response.data.cdCidade); 
      }
    } catch (error) {
      console.error(error);
    }
  };
  const convertDataFormat = (data: string) => {
    const [ano, mes, dia] = data.split("T")[0].split("-");
    return `${ano}-${mes}-${dia}`;
  };
  const fetchCidade = async (cdCidade: number) => {
    try {
      const response = await getCidade(cdCidade.toString());

      if (response.data) {
        setCidade(response.data);
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          cidade: response.data.nmCidade, 
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUsuario(cdUsuario);
  }, [cdUsuario]);
  
  return (
    <>
      <ToastContainer />
      <Helmet>
        <title>Alterar usuário</title>
      </Helmet>
      {usuario && (
        <div className="container">
          <div
            className="card bg-light mb-4 shadow p-3 mb-5 rounded"
            style={{ width: "auto", border: "none" }}
          >
            <div className="card-body">
              <div className="container">
                <div className="row align-items-start">
                  {formValues && (
                    <FormFieldsGroup
                      formValues={formValues}
                      validacaoAtiva={validacaoAtiva}
                      handleFieldChange={handleFieldChange}
                      handleMaskChange={handleMaskChange}
                      handleFieldBlur={handleFieldBlur}
                      mostrarSenha={false}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className="card bg-light shadow p-3 mb-1 bg-light rounded"
            style={{ width: "auto", border: "none" }}
          >
            <div className="card-body">
              <div className="container">
                <div className="row align-items-start">
                  {formValues && (
                    <CamposEndereco
                      formValues={formValues}
                      validacaoAtiva={validacaoAtiva}
                      handleFieldChange={handleFieldChange}
                      handleMaskChange={handleMaskChange}
                      handleFieldBlur={handleFieldBlur}
                      handleNumberChange={handleNumberChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="row align-items-center">
              <div className="row">
                <div className="col">
                  <div className="d-flex justify-content-start">
                    <div className="row">
                      <div className="row align-items-center">
                        <form className="mb-3" onSubmit={handleConfirmar}>
                          <div className="row">
                            <div className="col">
                              <div className="d-flex justify-content-end mt-5">
                                <a
                                  className="btn btn-outline-danger me-2 btn-sm"
                                  href="/milshop/usuario/consultar"
                                  role="button"
                                  style={{ width: "100px" }}
                                >
                                  Cancelar
                                </a>
                                <button
                                  type="submit"
                                  className="btn btn-outline-primary btn-sm"
                                  style={{ width: "100px" }}
                                >
                                  Alterar
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
